import React, { Component } from 'react';
import { reject } from 'lodash/fp';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import Table from 'components/shared/table';
import { Button } from 'ui';
import { updateItem } from 'utils/fp';
import SettingsHeading from 'components/settings/SettingsHeading';
import LabsBadge from 'components/shared/LabsBadge';
import WorkspaceRow from './WorkspaceRow';
import CreateWorkspace from './CreateWorkspace';

class WorkspacesIndex extends Component {
  state = {
    workspaces: [],
    createFormVisible: false,
  };

  componentDidMount() {
    request.get(routes.WORKSPACES.INDEX).then(response => {
      this.setState({ workspaces: response.workspaces });
    });
  }

  toggleCreateForm = () => {
    this.setState(state => ({ createFormVisible: !state.createFormVisible }));
  };

  onWorkspaceCreate = workspace => {
    this.setState(state => ({
      workspaces: state.workspaces.concat(workspace),
    }));
  };

  onWorkspaceDelete = workspace => {
    this.setState(state => ({
      workspaces: reject(workspace, state.workspaces),
    }));
  };

  onWorkspaceUpdate = workspace => {
    this.setState(({ workspaces }) => ({
      workspaces: updateItem(workspaces, { id: workspace.id }, workspace),
    }));
  };

  render() {
    const { workspaces, createFormVisible } = this.state;
    return (
      <div>
        <LabsBadge dark className="mb-4">
          <p>{t('workspaces.feature_description')}</p>
          <LabsBadge.FeedbackMessage />
        </LabsBadge>
        <SettingsHeading>{t('workspaces.content_workspaces')}</SettingsHeading>
        <Table>
          <Table.Body>
            {workspaces.map(workspace => (
              <WorkspaceRow
                key={workspace.id}
                workspace={workspace}
                onDelete={this.onWorkspaceDelete}
                onUpdate={this.onWorkspaceUpdate}
                disabled={createFormVisible || !workspace.id}
              />
            ))}
          </Table.Body>
          {createFormVisible && (
            <Table.Footer>
              <CreateWorkspace
                onDismiss={this.toggleCreateForm}
                onCreate={this.onWorkspaceCreate}
              />
            </Table.Footer>
          )}
        </Table>
        {!createFormVisible && (
          <Button onClick={this.toggleCreateForm} primary className="mt-16">
            {t('workspaces.new_workspace')}
          </Button>
        )}
      </div>
    );
  }
}

export default WorkspacesIndex;
